const defaultState = {
  code: '',
  info: {
    Created: 0,
  },
  log: [],
  history: [],
  path: '',
  files: [],
};

export default function(state = defaultState, action) {
  switch (action.type) {
    case 'UPDATE_CODE':
      return { ...state, code: action.code };
    case 'UPDATE_INFO':
      return { ...state, info: action.info };
    case 'SET_SOCKET':
      return { ...state, io: action.socket };
    case 'APPEND_LOG':
      // console.log(action.line, `==`, state.log[state.log.length - 1], state.log.length > 0 && action.line === state.log[state.log.length - 1])
      const split = action.line.split('\n');
      if (
        state.history.length > 0 &&
        split[0].trim() === state.history[0].trim()
      ) {
        const { log } = state;
        const lastLine = log.pop();
        return {
          ...state,
          log: [...log, `${lastLine} ${split.shift()}`, ...split],
        };
      } else {
        return { ...state, log: [...state.log, ...action.line.split('\n')] };
      }
    case 'APPEND_HISTORY':
      return { ...state, history: [action.line, ...state.history] };
    case 'CLEAR_LOG':
      return { ...state, log: [] };
    case 'SET_PATH':
      return { ...state, path: action.path };
    case 'SET_FOLDER_CONTENT':
      return { ...state, files: action.files };
    default:
      return state;
  }
}
